import {
  Column,
  DataGrid,
  DataGridTypes,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  StateStoring,
} from 'devextreme-react/data-grid'
import { TicketEditorDumpsProps } from '@/routes/tickets/TicketEditor.types'
import { ArraySourceComposer } from '@/auth/api/connector'
import { dump } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { useScreenSize } from '@/themes/media-query'
import { ObjectCodeLink } from '@/components/object-code-link/ObjectCodeLink'
import DateColumn from '@/components/date-column/DateColumn'
import { useEffect, useState } from 'react'
import { AzureUserInfo, getAzureUserInformation } from '@/auth/azure/azureManager'
import { isUserRoleAllowed } from '@/routes/utils'
import { Roles } from '@/auth/azure/Roles'
import { GridCellColor } from '@/enums'
import { CellPreparedEvent } from 'devextreme/ui/data_grid'
import { onCellPrepared } from '@/routes/dumps/utils'

const TicketEditorDumps = (props: TicketEditorDumpsProps) => {
  const { dumps, height = 550 } = props
  const currentScreenSize = useScreenSize()
  const [userInfo, setUserInfo] = useState<AzureUserInfo | undefined>()

  useEffect(() => {
    getAzureUserInformation().then((userInfo: AzureUserInfo | undefined) => {
      setUserInfo(userInfo)
    })
  }, [])

  return (
    <>
      <DataGrid
        id={`ticket-dumps-grid`}
        dataSource={ArraySourceComposer(
          'id',
          dumps?.sort((dumpA: dump, dumpB: dump) => {
            const dataA: Date = new Date(dumpA.data ?? '')
            const dataB: Date = new Date(dumpB.data ?? '')
            return dataB.getTime() - dataA.getTime()
          }),
        )}
        noDataText="Nessun dump associato al ticket"
        keyExpr={'id'}
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnHidingEnabled={currentScreenSize.isSmall || currentScreenSize.isXSmall || currentScreenSize.isMedium}
        allowColumnReordering={true}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        wordWrapEnabled={false}
        repaintChangesOnly={true}
        width="100%"
        height={height}
        onCellPrepared={onCellPrepared}
      >
        <StateStoring enabled={true} type="localStorage" storageKey={'ticket-dumps-grid'} savingTimeout={50} />
        <HeaderFilter visible={true} />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        <Column
          dataField={'ded_Dis'}
          caption={'DUMP ID'}
          cellRender={(cellData: DataGridTypes.ColumnCellTemplateData) => {
            const data: dump = cellData.row.data
            return (
              <ObjectCodeLink
                url={`/dumps/${data.id}`}
                text={data.ded_Dis}
                disabled={!isUserRoleAllowed(userInfo?.roles, [Roles.GlobalAdministrator, Roles.TechDeveloper])}
              ></ObjectCodeLink>
            )
          }}
          allowSorting={false}
        />
        {DateColumn({
          dataField: 'data',
          caption: 'DATA',
          width: 'auto',
          format: 'dd/MM/yyyy HH:mm',
          defaultSortOrder: 'desc',
          visible: true,
          allowSorting: false,
        })}
        <Column
          dataField={'licenza.chiave'}
          caption={'LICENZA'}
          cellRender={(cellData: DataGridTypes.ColumnCellTemplateData) => {
            const data: dump = cellData.row.data
            return (
              <ObjectCodeLink url={`/software/qs/${data.licenza?.id}`} text={data.licenza?.chiave}></ObjectCodeLink>
            )
          }}
          allowSorting={false}
        />
        <Column dataField={'stato.nome'} caption={'STATO'} allowSorting={false} />
      </DataGrid>
    </>
  )
}

export default TicketEditorDumps
